import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { UserDefinedFormLayoutCodes,IMUserDefinedFormLayoutCodes } from '../Layout';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import {UserDefinedFormLayoutReference} from '../Layout';
import { IM, WM } from "../../../../const/constants";

function UserDefinedTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;

    const handleFieldChangeCodes = useCallback((name, value, e) => {

    }, []);

    const handleFormLoadReference = useCallback((name, value, e) => {

    }, []);

    const handleDimensionFormLoadCodes = useCallback(() => {

    }, []);
    return (
        <>
            <div>
                <TabPanel className="TabpanelContainer">
                    <TabItem title="Codes">
                        <FormField
                            currrentUser={currentUser}
                            layoutId={props.Module===WM?'6CEB5C69-9602-4F8C-9BF3-50885BD4ACD5':'B5C8D8E3-1E3D-4F2D-8F2A-2F1E3C6D7B8A'}
                            layoutName='DimensionsForm'
                            defaultFormSchema={props.Module===WM? UserDefinedFormLayoutCodes :props.Module ===IM ? IMUserDefinedFormLayoutCodes : UserDefinedFormLayoutCodes}
                            formFields={props.formFields}
                            setformFields={props.setformFields}
                            handleFieldValueChange={handleFieldChangeCodes}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={props.formRefs}
                            onFormLoad={handleDimensionFormLoadCodes}
                            handleSelectedItemChange={handleFieldChangeCodes}
                        />
                    </TabItem>
                    <TabItem title="References">
                        <FormField
                            currrentUser={currentUser}
                            layoutId='e0027581-bbd2-4f76-aba8-d3f7a11e2040'
                            layoutName='ReferenceForm'
                            defaultFormSchema={UserDefinedFormLayoutReference}
                            formFields={props.formFields}
                            setformFields={props.setformFields}
                            handleFieldValueChange={handleFieldChangeCodes}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={props.formRefs}
                            onFormLoad={handleFormLoadReference}
                            handleSelectedItemChange={handleFieldChangeCodes}
                        />
                    </TabItem>

                </TabPanel>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedTab);